import { useContext } from "react";
import { AccordionContext } from "./AccordionProvider";

export default function useAccordionContext() {
    return useContext(AccordionContext);
};
